module.exports = {"610824001":"张家畔街道","610824101":"东坑镇","610824102":"青阳岔镇","610824103":"宁条梁镇","610824104":"周河镇","610824105":"红墩界镇","610824106":"杨桥畔镇","610824107":"王渠则镇","610824108":"中山涧镇","610824109":"杨米涧镇","610824110":"天赐湾镇","610824111":"小河镇","610824112":"龙洲镇","610824113":"黄蒿界镇","610824114":"海则滩镇","610824115":"席麻湾镇","610824116":"镇靖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610824.json
// module id = 2864
// module chunks = 0